import React from "react";
import { useTranslation } from "react-i18next";
import { Check, ChevronDown, Globe } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

const LANGS = [
  { code: "it", label: "IT", full: "Italiano" },
  { code: "de", label: "DE", full: "Deutsch" },
  { code: "en", label: "EN", full: "English" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher-trigger"
        className="inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white/80 px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-50 transition-colors"
      >
        <Globe className="w-3.5 h-3.5 text-slate-500" />
        <span>{current.label}</span>
        <ChevronDown className="w-3 h-3 text-slate-400" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[140px]">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => i18n.changeLanguage(l.code)}
            className="text-sm cursor-pointer flex items-center justify-between"
          >
            <span>{l.full}</span>
            {current.code === l.code && <Check className="w-3.5 h-3.5 text-blue-600" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
